@if (vm$ | async; as vm) {
  <div class="flex flex-col h-full relative">
    <aipb-inside-loading [loading]="vm.loading"></aipb-inside-loading>
    @if (items.length === 0) {
      <cat-ui-error-card
        [message]="'catalog.messages.no_results' | transloco"
      ></cat-ui-error-card>
    }
    @if (items.length > 0) {
      <mat-card class="flex-auto overflow-auto">
        @if (items.length > 0) {
          <cat-result-tab-group
            [activeTabIndex]="vm.activeTabIndex"
            [isMobile]="vm.isMobile"
            [items]="items"
            class="overflow-auto h-full"
          ></cat-result-tab-group>
        }
      </mat-card>
    }
  </div>
}
